import StyledSmallModal from './StyledSmallModal'

const SmallModal = props => (<StyledSmallModal {...props} />)

export default SmallModal
